import React, { useState } from "react";
import Main1 from "./Main1";
import Main2 from "./Main2";
import Header1 from "./Componants/Header1";
import Navbar from "./Componants1/Navbar";
import "./index.css";


export default function App() {
  const [isFirstMain, setIsFirstMain] = useState(true);

  const handleToggle = () => setIsFirstMain(!isFirstMain);

  return (
    <div className="transition-all duration-500 min-h-screen">

      {/* Toggle Header */}
      {isFirstMain ? (
        <Navbar handleToggle={handleToggle} />
      ) : (
        <Header1 handleToggle={handleToggle} />
      )}

      {/* Main switch */}
      {isFirstMain ? <Main1 /> : <Main2 />}
    </div>
  );
}
